import React, { useState, useEffect, useContext } from 'react'
import logoarteonuwhite from "@assets/images/pop_up_20250523.svg";
import DiscountPopup from './DiscountPopup';
import { TokenContext } from '@context/TokenContext';

function OldYear() {
    const { token, getToken } = useContext(TokenContext);
    const [showPopup, setShowPopup] = useState(() => {
        // Verificar si existe en localStorage
        const storedValue = localStorage.getItem('arteonu_old_year');
        return storedValue == null;
    });
    
    const [showDiscountPopup, setShowDiscountPopup] = useState(() => {
        const storedValue = localStorage.getItem('arteonu_old_year');
        const hasToken = !!getToken();
        const discountSeen = localStorage.getItem('arteonu_discount_popup') === 'true';
        return storedValue === 'true' && !hasToken && !discountSeen;
    });

    // Guardar en localStorage cuando cambie el estado
    useEffect(() => {
        if (!showPopup) {
            localStorage.setItem('arteonu_old_year', 'true');
        }
    }, [showPopup]);

    // Mostrar el popup de descuento solo si ya se confirmó la edad y no hay sesión
    useEffect(() => {
        const ageConfirmed = localStorage.getItem('arteonu_old_year') === 'true';
        const hasToken = !!(token || getToken());
        const discountSeen = localStorage.getItem('arteonu_discount_popup') === 'true';
        setShowDiscountPopup(ageConfirmed && !hasToken && !discountSeen);
    }, [showPopup, token, getToken]);

    const handleAgeConfirm = () => {
        setShowPopup(false);
        const hasToken = !!(token || getToken());
        const discountSeen = localStorage.getItem('arteonu_discount_popup') === 'true';
        setShowDiscountPopup(!hasToken && !discountSeen);
    };


    return (
        <div>
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <img src={logoarteonuwhite} alt="Logo" className="popup-img" />
                        <div className="grid">
                            <div>
                                <div className="text">You must be 18 years old or + to enter this site.</div>
                                <div className="text2">By entering you are agreeing to our <a href="/terminos-y-condiciones" target='_blank'>Terms and Conditions</a>,
                                <a href="/terminos-de-servicios" target='_blank'>Terms of Service</a> and <a href="/terminos-de-privacidad" target='_blank'>Privacy Policy.</a></div>
                            </div>
                            <div>
                                <div className="text">Debes tener 18 años o + para entrar a este sitio.</div>
                                <div className="text2">Al entrar aceptas <a href="/terminos-y-condiciones" target='_blank'>Términos y Condiciones</a>, <a href="/terminos-de-servicios" target='_blank'>Términos de
                                    Servicio</a> y <a href="/terminos-de-privacidad" target='_blank'>Políticas de Privacidad.</a></div>
                            </div>
                        </div>
                        <div className="grid mov">
                            <div>
                                <button className="ButtonDark" onClick={handleAgeConfirm}>I'M OVER 18 YEARS OLD</button>
                                <a href="/no-mayor-de-eddad" target="_blank" rel="noopener noreferrer">
                                    <button className="ButtonLightMedium left" >
                                        I'M <b>NOT</b> OVER 18 YEARS OLD
                                    </button>
                                </a>
                            </div>
                            <div>
                                <button className="ButtonDark" onClick={handleAgeConfirm}>SOY MAYOR DE EDAD</button>
                                <a href="/no-mayor-de-eddad" target="_blank" rel="noopener noreferrer">
                                    <button className="ButtonLightMedium right">
                                        <b>NO</b> SOY MAYOR DE EDAD
                                    </button>
                                </a>
                            </div>
                        </div>
                        {/* <h2>Si quieres visitar nuestro sitio web, debes tener 18 años o más.</h2>
                        <label className="custom-checkbox">
                        <input type="checkbox" />
                        <span className="checkmark"></span>
                        <a href="/terminos-de-servicios">Acepto términos de servicio</a>
                        </label>
                        <button className="ButtonDark" onClick={()=> setShowPopup(false)}>SOY MAYOR DE EDAD</button>
                        <button className="ButtonLightMedium" onClick={()=> navigate("/home")}>NO SOY MAYOR DE EDAD</button> */}
                        <div className="social">Follow us <div className="grid"> 
                            <a href="https://www.facebook.com/profile.php?id=61570059507003" target="_blank" className="facebook"></a> 
                            <a href="https://www.instagram.com/arteonu/" target="_blank" className="instagram"></a>
                        </div> ¡Síguenos!</div>
                    </div>
                </div>
            )}
            {showDiscountPopup && (
                <DiscountPopup onClose={() => setShowDiscountPopup(false)} />
            )}
        </div>
    );
}

export default OldYear;

